"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = ButtonGroup;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ToggleGroup = __importStar(require("@radix-ui/react-toggle-group"));
const constants_1 = require("../../../constants");
const Flex_1 = require("../../Flex");
const Label_1 = require("../../Form/Label");
const Icon_1 = require("../../Icon");
const StyledToggleGroup = (0, styled_1.default)(ToggleGroup.Root) `
  display: inline-grid;
  border: 1px solid ${constants_1.Color.DARK_MEDIUM_GREY};
  border-radius: 6px;
  overflow: hidden;
  height: fit-content;
  width: fit-content;
  box-shadow: ${constants_1.theme.boxShadow.normal};
`;
const StyledToggleItem = (0, styled_1.default)(ToggleGroup.Item) `
  padding: ${({ short }) => (short ? 4 : 6)}px
    ${({ thin }) => (thin ? 6 : 16)}px;
  font-size: ${({ short }) => (short ? 14 : 16)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  color: ${constants_1.Color.BLACK};
  background: ${constants_1.Color.WHITE};
  transition: all 0.3s ease-out;
  cursor: pointer;
  border: none;

  &:hover {
    background: ${constants_1.Color.LIGHTEST_BLUE};
  }

  &:not(:first-of-type) {
    border-left: 1px solid ${constants_1.Color.DARK_MEDIUM_GREY};
  }

  &[data-state='on'] {
    color: ${constants_1.Color.WHITE};
    background: ${constants_1.Color.BLUE};

    &:hover {
      background: ${constants_1.Color.DARK_BLUE};
    }
  }

  user-select: none;
`;
function ButtonGroup({ options, selectedOption, onClick, thin = false, short = false, label, my, ml, }) {
    const visibleOptions = options.filter((option) => !option.hidden);
    const handleValueChange = (value) => {
        // Convert the value back to the original type
        let typedValue;
        if (typeof selectedOption === 'boolean') {
            typedValue = (value === 'true');
        }
        else if (typeof selectedOption === 'number') {
            typedValue = Number(value);
        }
        else {
            typedValue = value;
        }
        onClick(typedValue);
    };
    const buttonGroup = ((0, jsx_runtime_1.jsx)(StyledToggleGroup, { type: "single", value: String(selectedOption), onValueChange: handleValueChange, style: {
            gridTemplateColumns: `${'1fr '.repeat(visibleOptions.length).trim()}`,
        }, children: visibleOptions.map((option) => ((0, jsx_runtime_1.jsxs)(StyledToggleItem, { thin: thin, short: short, value: String(option.value), children: [option.icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { my: 0.5, name: option.icon, size: "sm" }), option.label && (0, jsx_runtime_1.jsx)("span", { children: option.label })] }, `${option.value}`))) }));
    return ((0, jsx_runtime_1.jsx)(Flex_1.Flex, { col: true, styles: { my, ml }, children: label ? (0, jsx_runtime_1.jsx)(Label_1.Label, { text: label, children: buttonGroup }) : buttonGroup }));
}
